export const extractLanguageCode = (locale: string): string => locale.split("-")[0];
